import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const Twitter32: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(
      chroma === 'dark' ? s.svgLight32 : s.svgDark32,
      `svg-icon--${icon}`
    )}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    data-icon={getDataIconAttribute(chroma, icon, '32')}
  >
    <path
      d="M26.493 6.985c-.885.536-1.828.953-2.89 1.132-.825-.894-2.005-1.49-3.302-1.49-2.476 0-4.54 2.086-4.54 4.708 0 .357.059.715.118 1.072-3.774-.178-7.076-2.085-9.317-4.886-.413.715-.59 1.49-.59 2.383 0 1.61.826 3.04 2.005 3.933-.766 0-1.415-.238-2.064-.595v.059c0 2.264 1.534 4.171 3.656 4.589a3.776 3.776 0 01-1.179.178c-.295 0-.59 0-.825-.06.59 1.848 2.24 3.218 4.245 3.278-1.533 1.25-3.479 2.026-5.602 2.026-.353 0-.707 0-1.06-.06a12.602 12.602 0 006.957 2.086c8.314 0 12.914-7.15 12.914-13.348v-.596a8.829 8.829 0 002.24-2.443c-.825.358-1.71.656-2.594.715.766-.715 1.474-1.608 1.828-2.681"
      fill="#000"
      fillRule="evenodd"
    />
  </svg>
);

export default Twitter32;
